import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import styles from "@/components/ImpactReferenceSelector/ImpactReference.module.scss";
import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";
import useTableStateParams from "@/components/Table/hooks/useTableState";
import { useCompanyAccess } from "@/hooks/useCompanySettings";
import { ImpactDataset, useImpactDatasets } from "@/hooks/useEcoInventDatasets";

export interface MaterialImpactReferenceFullDatabaseProps {
  selectedDataset?: ImpactDataset;
  onDatasetChange: (id: ImpactDataset) => void;
  datasetType?: string;
  defaultSearch?: Record<string, any>;
  defaultFilter?: Record<string, any>;
  includeExiobase?: boolean;
}

export const Datasets = ({
  selectedDataset,
  onDatasetChange,
  datasetType,
  defaultSearch,
  defaultFilter,
  includeExiobase = false,
}: MaterialImpactReferenceFullDatabaseProps) => {
  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 20 },
    defaultFilter: defaultFilter,
    defaultSearch: { ...defaultSearch },
  });

  const newSearch = datasetType ? { dataset_type: datasetType, ...search } : { ...search };
  const access = useCompanyAccess();

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
    includeExiobase,
  });

  if (datasetType === "EPD" && access && !access.includes("epd")) {
    return <PremiumExplore />;
  }

  if (datasetType === "CUSTOM" && access && !access.includes("custom_impact_references")) {
    return <PremiumExplore />;
  }

  return (
    <>
      <div className={styles.form}>
        <DatasetTable
          loading={isLoading || isFetching}
          data={data?.datasets}
          columns={
            datasetType ? datasetTableColumns.filter((x) => x.key !== "dataset_type") : undefined
          }
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          totalRows={data?.total_count}
          pagination={pagination}
          sort={sort}
          search={search}
          filter={filter}
          onRowClick={(record) => onDatasetChange(record)}
          activeRowKey={selectedDataset?.id}
        />
      </div>
    </>
  );
};
